import React from 'react';
import { Image } from 'react-bootstrap';

interface AvatarProps {
  src?: string | null;
  alt?: string | null;
  size?: number;
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({
  src = null,
  alt = null,
  size = 32,
  className = '',
}) => {
  const imgSrc = src || '/images/placeholder-avatar.svg';

  return (
    <Image
      src={imgSrc}
      alt={alt || 'Avatar'}
      roundedCircle
      width={size}
      height={size}
      style={{ objectFit: 'cover' }}
      className={className}
    />
  );
};

export default Avatar;
